
const digest = 'afd33d9a88fcb5354642154503b740a13de36c8d4dda53dae4a611608a451544';
const classes = {"wrapper":"_wrapper_17h96_1","date":"_date_17h96_9","content":"_content_17h96_15","title":"_title_17h96_18","subTitle":"_subTitle_17h96_22"};
const css = `._wrapper_17h96_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 19px;
  gap: 28px;
  border-bottom: 1px solid #eaedf3;
}
._wrapper_17h96_1 ._date_17h96_9 {
  font-size: 14px;
  color: #000000;
  min-width: 120px;
  max-width: 120px;
}
._wrapper_17h96_1 ._content_17h96_15 {
  flex-grow: 1;
}
._wrapper_17h96_1 ._content_17h96_15 ._title_17h96_18 {
  color: #000000;
  font-weight: 500;
}
._wrapper_17h96_1 ._content_17h96_15 ._subTitle_17h96_22 {
  color: #000000;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  